export type QuizBannerContent = {
  topBannerPointsLabel: string;
  topBannerTitle: string;
  topBannerCta: string;
  bottomBannerTitle: string;
  bottomBannerEarnedTitle: string;
  bottomBannerCta: string;
  bottomBannerRedeemCta: string;
  bottomBannerRedeemUrl: string;
};

const POINTS_PLACEHOLDER = "{points}";

export const replacePointsPlaceholder = (template: string, points: number): string =>
  template.replaceAll(POINTS_PLACEHOLDER, String(points));

export const replaceProgressPlaceholders = (template: string, current: number, total: number): string =>
  template.replaceAll("{current}", String(current)).replaceAll("{total}", String(total));

export type QuizAnswerOption = {
  text: string;
  isCorrect: boolean;
};

export type QuizQuestionConfig = {
  title: string;
  description?: string;
  options: QuizAnswerOption[];
  correctFeedback: string;
  incorrectFeedback: string;
  nextButtonLabel: string;
};

export type QuizCompleteScreenConfig = {
  title: string;
  description: string;
  pointsLabel: string;
  defaultCtaLabel: string;
  ctas?: Array<{ label: string; url: string }>;
};

export const QUIZ_ANSWER_STATE = {
  idle: "idle",
  correct: "correct",
  incorrect: "incorrect",
} as const;

export type QuizAnswerState = (typeof QUIZ_ANSWER_STATE)[keyof typeof QUIZ_ANSWER_STATE];

export type QuizExitConfig = {
  title: string;
  description: string;
  dropQuizLabel: string;
  stayLabel: string;
};

export type QuizContentConfig = {
  questions: QuizQuestionConfig[];
  completeScreen: QuizCompleteScreenConfig;
  exitConfirmation: QuizExitConfig;
  accessibilityDialogLabel?: string;
  progressTemplate: string;
  successToastMessage: string;
  errorToastMessage: string;
  alreadyCompletedMessage: string;
  notAvailableMessage: string;
};
